<button
  *ngIf="onlyIcon; else normalButtons"
  mat-icon-button
  [color]="danger ? 'warn' : weight === 'tertiary' ? 'accent' : 'primary'"
  class="app-button--icon-only"
  [class.app-button--primary]="weight === 'primary'"
  [class.app-button--secondary]="weight === 'secondary'"
  [class.app-button--tertiary]="weight === 'tertiary'"
  [class.app-button--danger]="danger"
  [class.app-button--small]="small"
  [type]="type"
  [disabled]="disabled"
>
  <lib-icon [icon]="onlyIcon" class="app-button-icon" [inline]="small"></lib-icon>
</button>

<ng-template #normalButtons>
  <button
    *ngIf="weight === 'primary'"
    mat-flat-button
    [color]="danger ? 'warn' : 'primary'"
    class="app-button app-button--primary"
    [class.app-button--danger]="danger"
    [class.app-button--slim]="slim"
    [class.app-button--short]="short"
    [class.app-button--no-icon]="!icon"
    [type]="type"
    [disabled]="disabled"
  >
    <ng-container *ngTemplateOutlet="buttonContentTmp"></ng-container>
  </button>

  <button
    *ngIf="weight === 'secondary'"
    mat-stroked-button
    [color]="danger ? 'warn' : 'primary'"
    class="app-button app-button--secondary"
    [class.app-button--danger]="danger"
    [class.app-button--slim]="slim"
    [class.app-button--short]="short"
    [class.app-button--no-icon]="!icon"
    [type]="type"
    [disabled]="disabled"
  >
    <ng-container *ngTemplateOutlet="buttonContentTmp"></ng-container>
  </button>

  <button
    *ngIf="weight === 'tertiary'"
    mat-button
    [color]="danger ? 'warn' : 'primary'"
    class="app-button app-button--tertiary"
    [class.app-button--danger]="danger"
    [class.app-button--slim]="slim"
    [class.app-button--short]="short"
    [class.app-button--no-icon]="!icon"
    [type]="type"
    [disabled]="disabled"
  >
    <ng-container *ngTemplateOutlet="buttonContentTmp"></ng-container>
  </button>
</ng-template>

<!-- template enabling adding ng-content into *ngIf -->
<ng-template #buttonContentTmp>
  <lib-icon *ngIf="icon" [icon]="icon" class="mr1"></lib-icon><ng-content></ng-content>
</ng-template>
